Phaser.Easing.Custom = {
  SoftBounce: function(t) {
    var e=1.10158; return--t*t*((e+1)*t+e)+1;
  }
};
